import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataproviderService } from 'src/app/dataprovider.service';
import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { CommonService } from '../common.service';
import { CoverConfiguratorService } from '../cover-configurator/cover-configurator.service';
import { Header } from '../header.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-summary-view',
  templateUrl: './summary-view.component.html',
  styleUrls: [
    "./summary-view.component.scss",
    "./summary-view.component.responsive.scss"
  ],
  host: {
    class: "d-block p-y-page-summary h-100"
  }
})
export class SummaryViewComponent implements OnInit {
  title: string = "b2c.IDS_SUMMARY";
  subtitle: string = "b2c.IDS_SUMMARY_SUB";
  showSubtitle: boolean = false;
  question: string = "b2c.IDS_SUMMARY_QUE";
  activePage: string = "summary";
  nextPage: string = "findinstaller";    
  lateralPanelId: string = "summary-choices-lateral";
  plateUrl: string = "";
  switchesUrl: string = "";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "";
  summaryFormGroup: UntypedFormGroup;
  packageItemDownloaded: boolean = false;
  showLoader: boolean = true;
  minRange: number = 0;
  maxRange: number = 0;
  UUID: string;

  header: Header;
  pageSubscriptions: Subscription[] = [];
  
  constructor(
    private ar: ActivatedRoute,
    private ro: Router,
    private cs: CommonService,
    private ws: WebcallsService,
    public ds: DataproviderService,
    private confService: CoverConfiguratorService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.pageSubscriptions.push(
      this.cs.paramsHeaderChanged.subscribe((params: Header) => {
        this.header = params;
      })
    );
    this.cs.setParams(
      this.title,
      '',//this.subtitle,
      '',//this.question,
      this.activePage,
      this.nextPage,
      true,//f
      true,//g
      false,//h
      true,//i - center content
      null,
      false,///11-k
      false,
      this.eventCategory,
      this.eventLabel,
      false,
      'b2c.IDS_FOOTERTOOLTIP',
      true,
      this.showSubtitle
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(11);
    this.cs.updateNextPage(this.nextPage);
   }

  ngOnInit(): void {
    if (this.ds.getShapeID()) {
      this.eventLabel = "IDS_QUOTATION_SHAPE_"
        .concat(this.ds.getShapeID().toString())
        .concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString()));
    } else {
      this.eventLabel = "IDS_QUOTATION"
        .concat("_TECHNOLOGY_".concat(this.ds.getTechnologyID().toString()))
        .concat("_FINISHING")
        .concat(this.ds.getFinishingID().toString());
    }
    this.cs.setLabelEvent(this.eventLabel);    
    this.initForm();
    this.wsCall();
  }

  wsCall() {
    this.cs.changeSummaryLoaderStatus(true);
    let that = this;
    this.packageItemDownloaded = false;
    this.minRange=that.ds.getRangeMin();
    this.maxRange=that.ds.getRangeMax();
    that.packageItemDownloaded = true;
    that.showLoader=false;
    this.cs.changeSummaryLoaderStatus(false);
    this.cs.showFooter=true;
    this.updatePlateImageUrl();
    this.updateSwitchImageUrl();
  }

  initForm() {
    this.UUID = this.ds.getUUID();  
  }

  updatePlateImageUrl() {
    if (this.ds.getPlate()) {
      this.plateUrl = this.confService.getPlateUrl(this.ds.getPlate()["Code3"]);
    }
  }

  updateSwitchImageUrl() {
    if (this.ds.getSwitch()) {
      this.switchesUrl = this.confService.getSwitchUrl(
        this.ds.getSwitch()["id"],
        3
      );
    }
  }

}
